module.exports = __webpack_public_path__ + "img/box3_img.08bb636c.png";